import React, {useState, useEffect} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';

import {clientActions, locationActions, userActions, useSelector} from "inbooma-api";              // necessary to communicate with inbooma-react api
import {Biscuit } from "../../../../utils";               // necessary to communicate with inbooma-react
import {$,moment,_,CountryList} from "../../../../../vendor";

import Notification from "./Notification";
import {ADJUSTMENT_HELP_TEXT, HtmlTooltip} from "../../../../utils/HelperOld";

const ItemView = (props) => {

    const [location,setLocation] = useState(typeof props.location.id === 'undefined' ? {            // make a local copy of item or initialize a new item
        name: '',
        client_id: Number(Biscuit.get('user.client_id')),
        description: '',
        latitude: null,
        longitude: null,
        fe_visible: true,
        geofence: 0,
        location_addres: null,
        ssid: null,
        pre_booking_time: null,
        availability_rules: 'contingents',
        availability_checkin: 'reservation-only',
        minBookingDuration: null,
        maxBookingDuration: null,
        buffer: null
    } : props.location);

    const _patchLocation = useSelector(state => state.locations_data.patchLocation);
    const _postLocation = useSelector(state => state.locations_data.postLocation);

    const [userCreated,setUserCreated] = useState('-');
    const [userModified,setUserModified] = useState('-');
    const [userState,setUserState] = useState('init');                  // init, pending_created, ready_created, pending_modified, ready_modified
    const [clientState,setClientState] = useState('init');
    const _user = useSelector(state => state.users_data.user);
    const _client = useSelector(state => state.client_data.client);
    const role = Biscuit.get('user.role');
    let language = Biscuit.get('user.lang').replace('-','_');

    let _countryList = {};
    _countryList[""] = "";
    _.each(CountryList.getNames(Biscuit.get('user.lang').split('_')[0]),(key,val) => {
        _countryList[val] = key;
    });

    const [itemState,setItemState] = useState('init');
    const [notification,setNotification] = useState({
        message: "",
        show: false
    });

    const _initialize = () => {

        // fetch created_by and modified_by
        if (userState == 'init' && typeof location.id !== 'undefined' && location.id !== null) {
            if (typeof location.created_by !== 'undefined' && location.created_by !== null) {
                props.dispatch(userActions.getUser({
                    id: location.created_by,
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setUserState('pending_created');
            }
        }
        if (clientState == 'init' && (typeof location.id === 'undefined' || location.id === null) && props.action == 'add') {
            props.dispatch(clientActions.getClient({
                token: Biscuit.get('token'),
                client_id: Biscuit.get('user.client_id'),
                parameters: {
                    headers: {
                        "Accept-Language": (Biscuit.get('user.lang').replace('-', '_'))
                    }
                }
            }));
            setClientState('pending');
        }
    }

    useEffect(() => {

        if (itemState !== 'saving') return;

        if (_postLocation.success === true && _postLocation.actionState == 'POST_LOCATION_SUCCESS') {
            props.showNotification('success',_postLocation.data.id);
        }
        else if (_postLocation.success === false) {
            props.showNotification('warning', 0);
        }
        else if (_patchLocation.success === true && _patchLocation.actionState == 'PATCH_LOCATION_SUCCESS') {
            props.showNotification('success',location.id);
        }
        else if (_patchLocation.success === false) {
            props.showNotification('warning', location.id);
        }
        setTimeout(() => {
            abortButtonRef.current.click();
        },1000);
        

    },[_patchLocation,_postLocation]);

    useEffect(() => {

        if (_client.success == "") return;

        if (_client.success === true && clientState == 'pending') {
             if(typeof _client.data.client_templates[0] !== 'undefined'){
                 let template = _client.data.client_templates[0];
                 if(template.locations !== "" && template.locations !== null){
                     let locations = JSON.parse(template.locations);
                     let clone = {};
                     Object.assign(clone, location);
                     $.extend(clone,locations);
                     setLocation(clone);
                 }
             }
            setClientState('finished');
        }

        if (_client.success === false && clientState == 'pending') {
            props.dispatch(clientActions.getClient({
                client_id: location.client_id,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language
                    }
                }
            }));
            setClientState('pending');
        }
    },[_client]);

        useEffect(() => {

            if (_user.success == "") return;

            if (_user.success === true && userState == 'pending_created') {

                var name = '';
                if (_user.data.first_name !== null) name += _user.data.first_name + ' ';
                if (_user.data.last_name !== null) name += _user.data.last_name;
                setUserCreated(name);
                props.dispatch(userActions.getUser({
                    id: location.modified_by,
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setUserState('pending_modified');
            }
            else if (_user.success === true && userState == 'pending_modified') {
                var name = '';
                if (_user.data.first_name !== null) name += _user.data.first_name + ' ';
                if (_user.data.last_name !== null) name += _user.data.last_name;
                setUserModified(name);
                setUserState('ready_modified');
            }

            if (_user.success === false && userState == 'pending_created') {
                props.dispatch(userActions.getUser({
                    id: location.modified_by,
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setUserState('pending_modified');
            }
            else if (_user.success === false && userState == 'pending_modified') {
                setUserState('ready_modified');
            }
        },[_user]);


        _initialize();


    const getBookingUnit = (time) => {

        if (time !== null) {
            // value in seconds
            if (time % 86400 === 0) return 'days';

            if (time % 3600 === 0) return 'hours';

            return 'minutes';
        }
        return "minutes";
    };

    const getBookingCount = (time) => {

        if (time !== null) {

            const unit = getBookingUnit(time);
            
            if (unit === "minutes") return parseInt(time / 60);

            if (unit === "hours") return parseInt(time / 3600);

            return parseInt(time / 86400);
        }
        return "";
    };

    // evaluate form and send item to api
    const onSubmit = () => {

        if (location.name == '') {
            // show notification, mark field as required
            setNotification({
                message: t('no_empty_name_allowed',null,'capital'),
                show: true
            });
            return;
        }
        if (location.geofence === '' || location.geofence === null || location.geofence < 1) {
            // show notification, mark field as required
            setNotification({
                message: t('geofence must be higher than 0m.',null,'capital'),
                show: true
            });
            return;
        }
        let clone = {...location};
        if(typeof clone.contingents !== 'undefined'){
            delete clone.contingents;
        }
        if(typeof clone.check_in_periods !== 'undefined'){
            delete clone.check_in_periods;
        }
        if (typeof clone.id !== 'undefined' && clone.id != null) {
                // patch
                props.dispatch(locationActions.patchLocation({
                    location_id: Number(clone.id),
                    data: clone,
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
        }
        else {
            props.dispatch(locationActions.addLocation({
                data: clone,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }
        setItemState('saving');
    };

   const _showPopUp = (ev) => {
        let output = `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>` + t('info',null,'capital') + `</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; background-color: white  }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>` + t('availability_info') + `
            </body>
            </html>`;
        let rV = -1; // Return value assumes failure.

        if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {

            var uA = navigator.userAgent;
            var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

            if (rE.exec(uA) != null) {
                rV = parseFloat(RegExp.$1);
            }
            else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                rV = 11;
            }
        }

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const newWindow = window.open('', '', 'height=700,width=674');

        newWindow.document.body.innerHTML = '';
        newWindow.document.body.innerHTML = output;
        if (rV >=10 || isChrome) {
            newWindow.focus(); // necessary for IE >= 10*
        } else {
            // e.g. Firefox
            setTimeout(() => {
                newWindow.opener.focus();
            }, 0);
        }
        return true;
    }

    const onChangeForm = (e) => {

        var clone = {};
        Object.assign(clone, location);

        switch (e.target.name) {
            case 'name':
                clone.name = e.target.value;
                break;
            case 'description':
                clone.description = e.target.value;
                break;
            case 'latitude':
                clone.latitude = e.target.value;
                break;
            case 'longitude':
                clone.longitude = e.target.value;
                break;
            case 'geofence':
                clone.geofence = e.target.value;
                break;
            case 'ssid':
                clone.ssid = e.target.value;
                break;
            case 'city':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.city = e.target.value;
                break;
            case 'country':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.country = e.target.value;
                break;
            case 'street':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.street = e.target.value;
                break;
            case 'housenumber':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.house_number = e.target.value;
                break;
            case 'zip':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.zip_code = e.target.value;
                break;
            case 'phone':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.phone_number = e.target.value;
                break;
            case 'email':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.email = e.target.value;
                break;
            case 'organization':
                if (clone.location_addres === null) clone.location_addres = {};
                clone.location_addres.organization = e.target.value;
                break;
            case 'prebooking_count':
                const unit = document.getElementById('user_item_input_prebooking_unit').value;
                if (unit == 'minutes') clone.pre_booking_time = Number(e.target.value) * 60;
                if (unit == 'hours') clone.pre_booking_time = Number(e.target.value) * 3600;
                if (unit == 'days') clone.pre_booking_time = Number(e.target.value) * 3600 * 24;
                break;
            case 'prebooking_unit':
                const count = Number(document.getElementById('user_item_input_prebooking_count').value);
                if (e.target.value == 'minutes') clone.pre_booking_time = count * 60;
                if (e.target.value == 'hours') clone.pre_booking_time = count * 3600;
                if (e.target.value == 'days') clone.pre_booking_time = count * 3600 * 24;
                break;
            case 'minBookingDuration_count':
                const unit1 = document.getElementById('user_item_input_minBookingDuration_unit').value;
                if (unit1 == 'minutes') clone.minBookingDuration = Number(e.target.value) * 60;
                if (unit1 == 'hours') clone.minBookingDuration = Number(e.target.value) * 3600;
                if (unit1 == 'days') clone.minBookingDuration = Number(e.target.value) * 3600 * 24;
                break;
            case 'minBookingDuration_unit':
                const count1 = Number(document.getElementById('user_item_input_minBookingDuration_count').value);
                if (e.target.value == 'minutes') clone.minBookingDuration = count1 * 60;
                if (e.target.value == 'hours') clone.minBookingDuration = count1 * 3600;
                if (e.target.value == 'days') clone.minBookingDuration = count1 * 3600 * 24;
                break;
            case 'maxBookingDuration_count':
                const unit2 = document.getElementById('user_item_input_maxBookingDuration_unit').value;
                if (unit2 == 'minutes') clone.maxBookingDuration = Number(e.target.value) * 60;
                if (unit2 == 'hours') clone.maxBookingDuration = Number(e.target.value) * 3600;
                if (unit2 == 'days') clone.maxBookingDuration = Number(e.target.value) * 3600 * 24;
                break;
            case 'maxBookingDuration_unit':
                const count2 = Number(document.getElementById('user_item_input_maxBookingDuration_count').value);
                if (e.target.value == 'minutes') clone.maxBookingDuration = count2 * 60;
                if (e.target.value == 'hours') clone.maxBookingDuration = count2 * 3600;
                if (e.target.value == 'days') clone.maxBookingDuration = count2 * 3600 * 24;
                break;
            case 'buffer_count':
                const unit3 = document.getElementById('user_item_input_buffer_unit').value;
                if (unit3 == 'minutes') clone.buffer = Number(e.target.value) * 60;
                if (unit3 == 'hours') clone.buffer = Number(e.target.value) * 3600;
                if (unit3 == 'days') clone.buffer = Number(e.target.value) * 3600 * 24;
                break;
            case 'buffer_unit':
                const count3 = Number(document.getElementById('user_item_input_buffer_count').value);
                if (e.target.value == 'minutes') clone.buffer = count3 * 60;
                if (e.target.value == 'hours') clone.buffer = count3 * 3600;
                if (e.target.value == 'days') clone.buffer = count3 * 3600 * 24;
                break;
            case 'fe_visible':
                clone.fe_visible = e.target.checked;
                break;
            case 'oneway':
                clone.oneway = e.target.checked;
                break;
            case 'availability_rules':
                clone.availability_rules = e.target.value;
                break;
            case 'availability_checkin':
                clone.availability_checkin = e.target.value;
                break;

        }
        setLocation(clone);             // set object state
    };

    const closeNotification = () => {

        setNotification({
            ...notification,
            show: false
        });
    };

    const abortButtonRef = React.createRef();
    let returnUrl = (typeof props.requestPath !== 'undefined')?props.requestPath:'/locations';
    return (
      <>
        <div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
        {notification.show &&
        <>
            <Notification
            message={notification.message}
            close={closeNotification}>
            </Notification>
        </>
        }
        <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" aria-hidden="false">
            <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                <h1 className="inb-page-title">{(location !== null && location.id !== undefined && location.id != '') ? t('edit_${a}',{a:t('location')}) : t('add_${a}',{a:t('location')})}</h1>
                <div className="off-canvas__actions column">
                    <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title={t('save')} onClick={onSubmit}>
                        {itemState == 'init' &&
                        <>
                          <i className="fi fi-check"></i>
                          <span>{t('save')}</span>
                        </>
                        }
                        {itemState == 'saving' &&
                          <span><img className="rollingLoader" src="assets/img/rolling_loader.svg" />{t('save')}</span>
                        }
                    </button>
                    <a
                        href={returnUrl}>
                        <button ref={abortButtonRef} type="button" id="inb-tasksform-abort-button" className="button hollow secondary right button-abort round" title={t('close_window')} onClick={props.onClose}>
                            <i className="fi fi-x"></i>
                        </button>
                    </a>
                </div>
            </header>
            <p className="off-canvas__subtitle off-canvas__header-region">
                {typeof location.created !== 'undefined' &&
                t('created_at') + " " + moment(location.created).format('DD.MM.YYYY HH:mm:ss') + " " + 
                t('edited_by') + " " + userCreated + " | " +
                t('last_modified_at') + " " + moment(location.modified).format('DD.MM.YYYY HH:mm:ss') + " " + 
                t('edited_by') + " " + userModified
                }
            </p>
            <form className="off-content row">

                <div className="inb-form-group column medium-6 small-12 name">
                    <label className="inb-form__controlLabel">{t('name',null,'capital') + (location.id ? ' (ID: ' + location.id + ')' : '')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_name" type="text" className="form-control" name="name"
                                required="" autoComplete="false" placeholder="" value={location.name}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-6 small-12 description">
                    <label className="inb-form__controlLabel">{t('description',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_description" type="text" className="form-control" name="description"
                                required="" autoComplete="false" placeholder="" value={location.description}
                                onChange={(e) => onChangeForm(e)}/>
                        <span className="help-text">{t('locations_description_field_info')}</span>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 latitude">
                    <label className="inb-form__controlLabel">{t('latitude',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_latitude" type="text" className="form-control" name="latitude"
                                required="" autoComplete="false" placeholder="" value={location.latitude}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 longitude">
                    <label className="inb-form__controlLabel">{t('longitude',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_longitude" type="text" className="form-control" name="longitude"
                                required="" autoComplete="false" placeholder="" value={location.longitude}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 geofence">
                    <label className="inb-form__controlLabel">{t('geofence',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_geofence" type="text" className="form-control" name="geofence"
                                required="" autoComplete="false" placeholder="" value={location.geofence}
                                onChange={(e) => onChangeForm(e)}/>
                        <span className="help-text">{t('radius_in_meter')}</span>
                    </div>
                </div>

                <div className="inb-form-group column medium-12 small-12 ssid">
                    <label className="inb-form__controlLabel">{t('ssid',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_ssid" type="text" className="form-control" name="ssid"
                                required="" autoComplete="false" placeholder="" value={location.ssid}
                                onChange={(e) => onChangeForm(e)}/>
                        <span className="help-text">{t('ssid_of_network')}</span><br/>
                    </div>
                </div>

                <label className="inb-form__controlLabel" style={{width:'100%',marginLeft:'15px'}}>&nbsp;</label>


                    <div className="inb-form-group column medium-6 small-12 fe_visible">
                        <label className="inb-form__controlLabel">{t('fe_visible',null,'capital')}</label>
                        <div className="switch tiny inb-form__controllClass">
                            <input id="user_item_input_fe_visible" type="checkbox" className="switch-input" name="fe_visible" checked={location.fe_visible} onChange={onChangeForm}/>
                            <label className={"switch-paddle switch-paddle-" + Biscuit.get('user.client_id')} htmlFor="user_item_input_fe_visible">
                                <span className="show-for-sr">Toggle content</span>
                            </label>
                        </div>
                    </div>
                
                {Biscuit.get('client.isBikeSharing') !== 'true' &&
                    <div className="inb-form-group column medium-6 small-12 oneway">
                        <label className="inb-form__controlLabel">{t('oneway',null,'capital')}</label>
                        <div className="switch tiny inb-form__controllClass">
                            <input id="user_item_input_oneway" type="checkbox" className="switch-input" name="oneway" checked={location.oneway} onChange={onChangeForm}/>
                            <label className={"switch-paddle switch-paddle-" + Biscuit.get('user.client_id')} htmlFor="user_item_input_oneway">
                                <span className="show-for-sr">Toggle content</span>
                            </label>
                        </div>
                    </div>
                }

                <div className="inb-form-group column medium-4 small-12 organization">
                    <label className="inb-form__controlLabel">{t('organization',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_organization" type="text" className="form-control" name="organization"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.organization : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 street">
                    <label className="inb-form__controlLabel">{t('street',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_street" type="text" className="form-control" name="street"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.street : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 housenumber">
                    <label className="inb-form__controlLabel">{t('house_number',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_housenumber" type="text" className="form-control" name="housenumber"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.house_number : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 country">
                    <label className="inb-form__controlLabel">{t('country',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <select id="user_item_input_country" type="text" className="form-control"
                                name="country" placeholder="" value={location.location_addres !== null ? location.location_addres.country : ''}
                                onChange={onChangeForm}>
                            {Object.keys(_countryList).map((country, index) => {
                                return (
                                    <option key={index} value={country}>{_countryList[country]}</option>
                                );
                            })}
                        </select>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 city">
                    <label className="inb-form__controlLabel">{t('city',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_city" type="text" className="form-control" name="city"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.city : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-12 zip">
                    <label className="inb-form__controlLabel">{t('zip',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_zip" type="text" className="form-control" name="zip"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.zip_code : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-6 small-12 phone">
                    <label className="inb-form__controlLabel">{t('phone_number',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_phone" type="text" className="form-control" name="phone"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.phone_number : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-6 small-12 email">
                    <label className="inb-form__controlLabel">{t('email',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_email" type="text" className="form-control" name="email"
                                required="" autoComplete="false" placeholder="" value={location.location_addres !== null ? location.location_addres.email : ''}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div style={{width: "50%", float: "left"}}>
                    <label className="inb-form__controlLabel" style={{width:'100%',marginLeft:'15px'}}>{t('pre_booking_time',null,'capital')}</label>

                    <div className="inb-form-group column medium-2 small-12 prebooking_count float-left">
                        <label className="inb-form__controlLabel">{t('count_units',null,'capital')}</label>
                        <div className="inb-form__controllClass">
                            <input id="user_item_input_prebooking_count" type="text" className="form-control" name="prebooking_count"
                                   required="" autoComplete="false" placeholder="" value={getBookingCount(location.pre_booking_time)}
                                   onChange={(e) => onChangeForm(e)}/>
                        </div>
                    </div>

                    <div className="inb-form-group column medium-3 small-12 prebooking_unit float-left">
                        <label className="inb-form__controlLabel">{t('units')}</label>
                        <div className="inb-form__controllClass">
                            <select id="user_item_input_prebooking_unit" className="form-control" name="prebooking_unit" required="" placeholder="" value={getBookingUnit(location.pre_booking_time)} onChange={(e) => onChangeForm(e)}>
                                <option value="minutes">{t('minutes')}</option>
                                <option value="hours">{t('hours')}</option>
                                <option value="days">{t('days')}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div style={{width: "50%", float: "left"}}>
                <label className="inb-form__controlLabel" style={{width:'100%',marginLeft:'15px'}}>{t('service_transport',null,'capital')}</label>

                <div className="inb-form-group column medium-2 small-12 buffer_count float-left">
                    <label className="inb-form__controlLabel">{t('count_units',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_buffer_count" type="text" className="form-control" name="buffer_count"
                                required="" autoComplete="false" placeholder="" value={getBookingCount(location.buffer)}
                                onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-3 small-12 buffer_unit float-left">
                    <label className="inb-form__controlLabel">{t('units')}</label>
                    <div className="inb-form__controllClass">
                        <select id="user_item_input_buffer_unit" className="form-control" name="buffer_unit" required="" placeholder="" value={getBookingUnit(location.buffer)} onChange={(e) => onChangeForm(e)}>
                            <option value="minutes">{t('minutes')}</option>
                            <option value="hours">{t('hours')}</option>
                            <option value="days">{t('days')}</option>
                        </select>
                    </div>
                </div>
                </div>

                <div className="inb-form-group column medium-12 small-12">

                </div>

                <div style={{float: "left", width: "100%",  borderBottom: "solid 0.5px", borderTop: "solid 0.5px", marginTop: "16px", fontSize: "16px", marginBottom: "16px"}}>
                    <label className="inb-form__controlLabel" style={{width: "50%", marginLeft: "15px", float: "left"}}>{t('availability_check_options',null,'capital')}</label>
                    <label className="inb-form__controlLabel" style={{width: "47%", marginRight: "15px", textAlign: "right", float: "left"}}><HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={'Info::ALERT' + t('Bitte klicken um weitere Informationen zu erhalten', null, 'capital')+'//'}/>}</React.Fragment>}>
                        <a href="#" onClick={(e) => _showPopUp(e)}><i className="inb-ico fi fi-info"> {t('info',null,'capital')}</i></a></HtmlTooltip></label>
                </div>
                <label className="inb-form__controlLabel" style={{width:'100%',marginLeft:'15px'}}>{t('booking_duration_options',null,'capital')}</label>
                <div style={{width: "50%", float: "left"}}>
                <label className="inb-form__controlLabel" style={{width:'100%',marginLeft:'15px'}}>{t('minBookingDuration',null,'capital')}</label>
                <div className="inb-form-group column medium-2 small-12 prebooking_count" style={{float: "left"}}>
                    <label className="inb-form__controlLabel">{t('count_units',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_minBookingDuration_count" type="text" className="form-control" name="minBookingDuration_count" disabled={(role !== 'admin')}
                               required="" autoComplete="false" placeholder="" value={getBookingCount(location.minBookingDuration)}
                               onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>
                <div className="inb-form-group column medium-3 small-12 prebooking_unit" style={{float: "left"}}>
                    <label className="inb-form__controlLabel">{t('units')}</label>
                    <div className="inb-form__controllClass">
                        <select id="user_item_input_minBookingDuration_unit" className="form-control" name="minBookingDuration_unit"
                                required="" placeholder="" value={getBookingUnit(location.minBookingDuration)} disabled={(role !== 'admin')}
                                onChange={(e) => onChangeForm(e)} >
                            <option value="minutes">{t('minutes')}</option>
                            <option value="hours">{t('hours')}</option>
                            <option value="days">{t('days')}</option>
                        </select>
                    </div>
                </div>
                </div>
                <div style={{width: "50%", float: "left"}}>
                <label className="inb-form__controlLabel" style={{width:'100%',marginLeft:'15px'}}>{t('maxBookingDuration',null,'capital')}</label>
                <div className="inb-form-group column medium-2 small-12 prebooking_count" style={{float: "left"}}>
                    <label className="inb-form__controlLabel">{t('count_units',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input id="user_item_input_maxBookingDuration_count" type="text" className="form-control" name="maxBookingDuration_count" disabled={(role !== 'admin')}
                               required="" autoComplete="false" placeholder="" value={getBookingCount(location.maxBookingDuration)}
                               onChange={(e) => onChangeForm(e)}/>
                    </div>
                </div>
                <div className="inb-form-group column medium-3 small-12 prebooking_unit" style={{float: "left"}}>
                    <label className="inb-form__controlLabel">{t('units')}</label>
                    <div className="inb-form__controllClass">
                        <select id="user_item_input_maxBookingDuration_unit" className="form-control" name="maxBookingDuration_unit" disabled={(role !== 'admin')}
                                required="" placeholder="" value={getBookingUnit(location.maxBookingDuration)}
                                onChange={(e) => onChangeForm(e)}>
                            <option value="minutes">{t('minutes')}</option>
                            <option value="hours">{t('hours')}</option>
                            <option value="days">{t('days')}</option>
                        </select>
                    </div>
                </div>
                </div>

                <div className="inb-form-group column large-12 medium-12 small-12 availability_rules">
                    <label className="inb-form__controlLabel">{t('availability_rules',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <select id="user_item_input_availability_rules" type="text" className="form-control" name="availability_rules" disabled={(role !== 'admin')}
                               required="" placeholder="" value={location.availability_rules}
                               onChange={(e) => onChangeForm(e)}>
                            <option value="contingents">{t('contingents_only')}</option>
                            <option value="contingents_prebooking_blocked">{t('contingents_prebooking_blocked')}</option>
                            <option value="contingents_prebooking_resources">{t('contingents_prebooking_resources')}</option>
                            <option value="contingents_prebooking_request">{t('contingents_prebooking_request')}</option>
                        </select>
                    </div>
                </div>

                <div className="inb-form-group column large-12 medium-12 small-12 availability_checkin">
                    <label className="inb-form__controlLabel">{t('availability_checkin')}</label>
                    <div className="inb-form__controllClass">
                        <select id="user_item_input_availability_checkin" type="text" className="form-control" disabled={(role !== 'admin')} name="availability_checkin" required="" autoComplete="false" placeholder="" value={location.availability_checkin} onChange={onChangeForm}>
                            <option value="reservation-only">{t('reservation-only')}</option>
                            <option value="checkin">{t('checkin')}</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
      </>
    );
};

export default ItemView;